import type { Enums, ProtocolPriorityType } from "@msuite/utils/types";
import type { IconName } from "./icons";

/**
 * TThis function returns the icon name for a given protocol priority.
 * @param priority
 * @returns
 */
export function getProtocolPriorityIcon(priority: ProtocolPriorityType): IconName {
	switch (priority) {
		case "low":
			return "ChevronDown";
		case "medium":
			return "Minus";
		case "high":
			return "ChevronUp";
		case "very-high":
			return "ChevronsUp";
		case "custom":
			return "Star";
	}
}

export function getProtocolPriorityColor(priority: ProtocolPriorityType): Enums<"color"> {
	switch (priority) {
		case "low":
			return "blue";
		case "medium":
			return "amber";
		case "high":
			return "orange";
		case "very-high":
			return "red";
		case "custom":
			return "indigo";
	}
}
